/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {AsideMenuItem} from './AsideMenuItem'

export function AsideMenuMain() {
  const intl = useIntl()

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/bookings'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.BOOKINGS'})}
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/go-checkin'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.GO_CHECKIN'})}
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/customers'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.CUSTOMER'})}
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/coupons'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.COUPON'})}
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItem
        to='/marketing'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.MARKETING'})}
        fontIcon='bi-app-indicator'
      />
    </>
  )
}
